import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70b6c2b5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=70b6c2b5&prod&scoped=true&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=70b6c2b5&prod&lang=scss&scoped=true"
import style2 from "./index.vue?vue&type=style&index=2&id=70b6c2b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6c2b5",
  null
  
)

export default component.exports